import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';

var _components;

import './index.css';
import {createNamespace} from '../../common/utils';
import {raf} from '../../common/utils/raf';
import {getComponentName} from '../../common/utils/namespace';
import icon from '../icon';
import scrollDetector from '../scroll-detector';
import {getScroller, getScrollTop, setScrollTop} from '../../common/utils/dom';

var _createNamespace = createNamespace('back-top'),
    _createNamespace2 = _slicedToArray(_createNamespace, 1),
    bem = _createNamespace2[0];

export function scrollToTop(el) {
    var step = 0;

    var handler = function handler() {
        var containerSt = getScrollTop(el);

        if (containerSt <= 0) {
            return;
        } else {
            raf(handler);
        }

        step += 10;
        setScrollTop(el, containerSt - step);
    };

    raf(handler);
}
export default {
    name: getComponentName('BackTop'),
    components:
        ((_components = {}),
        _defineProperty(_components, icon.name, icon),
        _defineProperty(_components, scrollDetector.name, scrollDetector),
        _components),
    props: {
        target: {
            type: Function,
            default: function _default() {
                return getScroller(this.$el);
            }
        },
        visibilityHeight: {
            type: Number,
            default: 0
        },
        referQuery: {
            type: Function,
            default: function _default() {
                return getScroller(this.$el);
            }
        },
        referNum: {
            type: Number,
            default: 2
        },
        color: {
            type: String,
            default: ''
        },
        bottom: {
            type: Number,
            default: 0
        },
        right: {
            type: Number,
            default: 0
        }
    },
    computed: {
        styleBottom: function styleBottom() {
            return ''.concat(this.bottom, 'px');
        },
        styleRight: function styleRight() {
            return ''.concat(this.right, 'px');
        }
    },
    methods: {
        onHandleClick: function onHandleClick(e) {
            scrollToTop(this.$refs.instance.el);
            this.$emit('click', e);
        },
        getStyle: function getStyle() {
            var style = {};
            var color = this.color,
                bottom = this.bottom,
                right = this.right;

            if (color) {
                style['color'] = color;
            }

            if (bottom) {
                style['bottom'] = ''.concat(bottom, 'px');
            }

            if (right) {
                style['right'] = ''.concat(right, 'px');
            }

            return style;
        }
    },
    render: function render() {
        var _this = this;

        var h = arguments[0];
        var style = this.getStyle();
        var scopedSlots = {
            default: function _default(_ref) {
                var visible = _ref.visible;
                return h(
                    'div',
                    {
                        class: [bem()],
                        on: {
                            click: _this.onHandleClick
                        },
                        style: style,
                        directives: [
                            {
                                name: 'show',
                                value: visible
                            }
                        ]
                    },
                    [
                        _this.$slots.default
                            ? _this.$slots.default
                            : h('mai-icon', {
                                  attrs: {
                                      color: '#3E3A39',
                                      name: 'to-top'
                                  }
                              })
                    ]
                );
            }
        };
        return h('mai-scroll-detector', {
            attrs: {
                'back-scroll': true,
                'refer-num': this.referNum,
                'refer-query': this.referQuery,
                target: this.target,
                'visibility-height': this.visibilityHeight
            },
            ref: 'instance',
            scopedSlots: scopedSlots
        });
    },
    install: function install(Vue) {
        Vue.component(this.name, this);
    }
};
